import React, { Component } from "react";
import Link from "react-router/lib/Link";
import { StyleSheet, css } from "aphrodite";
import { browserHistory } from "react-router";
import { connect } from "react-redux";
import { logoutRequest } from "../../actions/login";
import "./Nav.css";

class Nav extends Component {
  handleLogout = () => {
    this.props.logoutRequest();
    console.log('Hey')
  };

  componentDidUpdate(prevProps) {
    const { isLoggedIn } = this.props;

    if (prevProps.isLoggedIn && !isLoggedIn) {
      browserHistory.replace("/");
    }
  }

  render() {
    return (
      <div className="topBar">
        <div className="flex">
          <h1 className={css(styles.title)}>PicNow</h1>
        </div>
        {!this.props.onlyTitle && (
          <div className="topBar_right">
            <ul className="topBar_authBar">
              <Link to="/DashBoard" style={{ marginLeft: "10px" }}>
                <li className="topBar_btn">
                  <span>Dashboard</span>
                </li>
              </Link>
              <Link to="/PictureManagement">
                <li className="topBar_btn">
                  <span>Picture Management</span>
                </li>
              </Link>
              <Link to="/UserManagement">
                <li className="topBar_btn">
                  <span>User Management </span>
                </li>
              </Link>
              <li className="topBar_btn">
                <button className={"btn btn-danger"} onClick={this.handleLogout}>
                  Log out
                </button>
              </li>
            </ul>
          </div>
        )}
      </div>
    );
  }
}

const styles = StyleSheet.create({
  link: {
    maxWidth: 700,
    color: "#999",
    margin: "1.5rem 1rem 1.5rem 0",
    display: "inline-block",
    textDecoration: "none",
    fontWeight: "bold",
    transition: ".2s opacity ease",
    ":hover": {
      opacity: 0.6
    }
  },
  activeLink: {
    color: "#000"
  },
  title: {
    color: "#000",
    maxWidth: 300,
    fontWeight: "bold",
    fontSize: 56
  }
});

const mapStateToProps = state => {
  return {
    isLoggedIn: state.auth.isLoggedIn,
    universityFirebase: state.auth.universityFirebase
  };
};

const mapDispatchToProps = dispatch => ({
  logoutRequest: () => dispatch(logoutRequest())
});

export default connect(mapStateToProps, mapDispatchToProps)(Nav);



// WEBPACK FOOTER //
// /src/components/Nav/Nav.js